import { ArrowBigUpDash, Check, FolderKanban, ReceiptSwissFranc, X } from "lucide-react";
import React, { useState, useEffect } from "react";

export default function DragMatch({ question,sendRawdata,rawData,element ,onAttemptUpdate}) {
  const [data, setData] = useState(rawData?rawData:[]);
  const [score, setScore] = useState(null); // store calculated score

  // 🔹 Parse and shuffle right-side boxes (optionTitle)
  const shuffleBoxes = () => {
    if (element?.dropdownValues) {
      const parsed = JSON.parse(element?.dropdownValues);
      const shuffled = [...parsed].sort(() => Math.random() - 0.5);
      setData(shuffled);
    }
  };

  useEffect(() => {
    // console.log(element)
    shuffleBoxes(); // shuffle on mount
  }, [element]);

  // 🔹 Matches: optionTitle -> optionTitle2
  const [matches, setMatches] = useState({});
  const [draggedItem, setDraggedItem] = useState(null);

  const handleDragStart = (e, payload) => {
    e.dataTransfer.setData("text/plain", JSON.stringify(payload));
    setDraggedItem(payload.dragValue);
  };

  const handleDrop = (e, targetValue) => {
    e.preventDefault();
    const { type, dragValue } = JSON.parse(
      e.dataTransfer.getData("text/plain")
    );

    if (type === "item") {
      // Dropping from pool → box
      const updated = Object.fromEntries(
        Object.entries(matches).filter(([_, v]) => v !== dragValue)
      );
      updated[targetValue] = dragValue;
      setMatches(updated);
    } else if (type === "answer") {
      // Reorder matched values between boxes
      const updated = { ...matches };
      const fromBox = Object.keys(matches).find(
        (key) => matches[key] === dragValue
      );
      if (fromBox) delete updated[fromBox];
      updated[targetValue] = dragValue;
      setMatches(updated);
    } else if (type === "back") {
      // Drag from box → pool (unmatch)
      const updated = Object.fromEntries(
        Object.entries(matches).filter(([_, v]) => v !== dragValue)
      );
      setMatches(updated);
    }

    setDraggedItem(null);
  };

const [dragOverIndex, setDragOverIndex] = useState(null);
const handleDragOver = (e, index) => {
  e.preventDefault();
  setDragOverIndex(index);
};

const handleDragEnd = () => {
  setDragOverIndex(null);
};
  
  // 🔹 Reset matches and reshuffle right boxes
  const resetMatches = () => {
    setMatches({});
    setScore(null);
    shuffleBoxes();
  };

  // 🔹 Calculate total score
  const checkResults = () => {
    let total = 0;
    let correctCount = 0;
    data.forEach((item) => {
      const matched = matches[item?.optionTitle];
      if (matched === item?.optionTitle2) {
        correctCount++;
        total += item?.partialMarksChoice || 1; // default 1 mark if not specified
      }
    });
    const maxMarks = data.reduce(
      (sum, item) => sum + (item?.partialMarksChoice || 1),
      0
    );
    setScore({ total, correctCount, maxMarks });
 
     onAttemptUpdate({
    questionId: question?.ID,
  queType: "Drag Matching",
  score: total,
  rawScore: { total, correctCount, maxMarks },
  status:correctCount==0?"wrong": correctCount==data.length?"correct":"partially-correct",
  isCorrect: correctCount==data.length?true:false,
    selectedOptionIds: [], // always empty for dragMatch
    userAnswer: null,
    dragMatches: matches
  });

  };


  const handleSubmit = () => {
  const parsed = JSON.parse(element.dropdownValues);

  const matchedIds = Object.values(matches) // ["MoMoTo", ...]
    .map(match => {
      const found = parsed.find(item => item.optionTitle2 === match);
      return found?.id;
    })
    .filter(Boolean);

  // Store in attempt object for evaluator
  // This should be passed from parent component
 
};
  const usedItems = Object.values(matches);

  if (!data.length) return null;

  return (
    <div>
    <div
      style={element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?{
        display: "flex",
        gap: "5px",
        padding: "0px",
        fontFamily: "sans-serif",
        flexWrap: element?.optionBoxAlign=="Up"?"wrap-reverse":"wrap",
        flexDirection:element?.optionBoxAlign=="Up"?"column":"column-reverse"
      }:{
        display: "flex",
        gap: "5px",
        padding: "0px",
        fontFamily: "sans-serif",
        justifyContent:"space-between"
      }}
    >
      {/* LEFT SIDE — Pool of draggable items */}
      <div
        onDrop={(e) => handleDrop(e, null)}
        onDragOver={handleDragOver}
         onDragEnd={handleDragEnd}
        style={{
         
          padding: "0px",
          borderRadius: "8px",
          minHeight: "50px",
        }}
      >

       
        <h3>Draggable Items </h3><div style={element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?{
        display: "flex",
        gap: "5px",
        padding: "0px",
        fontFamily: "sans-serif",
        flexWrap: "wrap",
        flexDirection:"row"
      }:{
        gap: "5px",
        padding: "0px",
        fontFamily: "sans-serif",
    
             }}>
        {JSON.parse(element?.dropdownValues).map((item, index) => {
          const isUsed = usedItems.includes(item?.optionTitle2);
          return (
            <div
              key={item?.id}
              draggable={!isUsed}
              onDragStart={(e) =>
                handleDragStart(e, { type: "item", dragValue: item?.optionTitle2 })
              }
              style={{
                position: "relative",
                margin: "3px",
                background: isUsed ? "rgba(235, 236, 237, 1)" : "#ffffff",
                boxShadow: "0 7px 20px 0 rgba(1,1,1,0.0501)",
                padding: "10px 10px",
                border: isUsed
                  ? "3px solid #fff"
                  : "3px solid rgba(235, 236, 237, 1)",
                borderRadius: "6px",
                opacity: isUsed ? 0.5 : 1,
                cursor: isUsed ? "not-allowed" : "grab",
                textAlign: "center",
                minWidth: element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?"80px":"90px",
                minHeight: "25px",
              }}
            >
              {isUsed ? "" : item?.optionTitle2}
              <div
                style={{
                  position: "absolute",
                  top: "-5px",
                  right: "-5px",
                  padding: "2px",
                  background: isUsed ? "rgba(235, 236, 237, 1)" : "#ffffff",
                  boxShadow: "0 7px 20px 0 rgba(1,1,1,0.0501)",
                  border: isUsed
                    ? "3px solid #fff"
                    : "3px solid rgba(235, 236, 237, 1)",
                  borderRadius: "6px",
                }}
              >
                {index + 1}
              </div>
            </div>
          );
        })}</div>
      </div>

      {/* RIGHT SIDE — Shuffled Boxes */}
      <div>
       <h3>Choices/ Answers:</h3>
      <div style={element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?{
        display: "flex",
        gap: "5px",
        padding: "0px",
        fontFamily: "sans-serif",
        flexWrap: "wrap",
        flexDirection:"row"
      }:{
        gap: "5px",
        padding: "0px",
        fontFamily: "sans-serif",
    
             }}>
       
        {data.map((item,index) => {
          const matched = matches[item?.optionTitle];
           const showDropZone = dragOverIndex === index;

          const correct = matched === item?.optionTitle2;
          const bgColor = matched
            ? correct
              ? "#c8f7c5"
              : "#f7c5c5"
            : "";
const correctStatus = matched
            ? correct
              ? true
              : false
            : false;
          return (
            <div
              key={item?.optionTitle}
              onDrop={(e) => handleDrop(e, item?.optionTitle)}
              onDragOver={(e) => handleDragOver(e, index)}
          onDragEnd={handleDragEnd}
         style={{position:"relative",flexDirection:"column",
                margin: "3px",
                padding: "10px 10px",
                border: score&&bgColor?"2px dashed "+bgColor+"":"2px dashed rgba(235, 236, 237, 1)",
                borderRadius: "6px",
                maxWidth: element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?"150px":"100%",
                 minWidth: element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?"150px":"150px",
               minHeight: "35px",
                display: "flex",
                
                alignItems:  element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?"center":"",
                background: "#ffffff",
              }}
            > 
             <div
                style={{
                  position: "absolute",
                  top: "35%",width:"20px",height:"20px",borderRadius:"50%",
                 left: "-10px",display:"flex",justifyContent:"center",alignItems:"center",
                 
                  background: "#ffffff",
                  boxShadow: "0 7px 20px 0 rgba(1,1,1,0.0501)",
               border: score&&bgColor?"2px solid "+bgColor+"":"2px solid rgba(235, 236, 237, 1)",
                 
                }}
              >
                {score&&correctStatus?<Check size={15} color={bgColor}/>:score&&!correctStatus?<X size={15} color={"#f7c5c5"} />:index+1}
              </div>
            
             {score?<div
                style={{
                  position: "absolute",
                  top: "-15px",
                  right: "-10px",
                  padding: "3px",
                  background: "#ffffff",
                  boxShadow: "0 7px 20px 0 rgba(1,1,1,0.0501)",
               border: score&&bgColor?"2px solid "+bgColor+"":"2px solid rgba(235, 236, 237, 1)",
                  borderRadius: "6px",
                }}
              >
                {correctStatus?"+":"-"}{item?.partialMarksChoice} Marks
              </div>:""} 
              <span style={{display:element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?"flex":"flex",justifyContent:element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?"center":"space-between",flexDirection:element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?"column":"row"}}>
                <strong
                  draggable
                  onDragStart={(e) =>
                    handleDragStart(e, {
                      type: "answer",
                      dragValue: matched,
                      fromValue: item?.optionTitle,
                    })
                  }
                  style={{
                    position: "relative",
                    margin: "3px",top: element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?"":"0px",
                  
                    padding: "5px 10px",
                     minHeight: "25px",
                  }}
                >{item?.optionTitle}
               </strong> 
              {matched ? (
                <strong
                  draggable
                  onDragStart={(e) =>
                    handleDragStart(e, {
                      type: "answer",
                      dragValue: matched,
                      fromValue: item?.optionTitle,
                    })
                  }
                  style={{
                    cursor: "grab",
                    background: "#eee",
                    position: "relative",
                    margin: "3px",top: element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?"":"0px",
                    background: "#ffffff",
                    boxShadow: "0 7px 20px 0 rgba(1,1,1,0.0501)",
                    padding: "5px 10px",
                    border: "3px solid rgba(235, 236, 237, 1)",
                    borderRadius: "6px",
                    textAlign: "center",
                    minWidth: element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?"35px":"30px",
                    minHeight: "25px",
                  }}
                >
                  {matched}
                </strong>
              ) : (
                <strong style={{
                    position: "relative",
                    margin: "3px",top: element?.optionBoxAlign=="Up"||element?.optionBoxAlign=="Down"?"":"0px",
                  
                    padding: "5px 0px",
                     minHeight: "25px",
                  }}></strong>
              )}</span>

               {showDropZone && (
          <div
            onDragOver={(e) => handleDragOver(e, index)}
            onDrop={(e) => handleDrop(e, index)}
            style={{
              height: "30px",fontSize:"12px",width:"100%",
              margin: "px 0",display:"flex",justifyContent:"center",alignItems:"center",color:"#555",
              borderRadius: "6px",
              background: "rgba(144,202,249,0.2)",
              transition: "0.2s",
            }}
          >Drop Here</div>
        )}
            </div>
          );
        })}

      </div></div>
       
    </div>
     {/* 🔘 Buttons */}
        <div style={{ display: "flex", gap: "5px", marginTop: "15px" }}>
          <button
            onClick={resetMatches}
            style={{
              flex: 1,
              padding: "8px 12px",
              borderRadius: "6px",
              border: "none",border:"2px solid rgba(144, 202, 249,1)",
              background: "rgba(144, 202, 249,1)",
              color: "#ffffff",
              cursor: "pointer",
            }}
          >
            <div style={{display:"flex",justifyContent:"left",gap:"10px",width:"130px"}}>
            <FolderKanban color="#ffffff" size={20}/> Reset & Shuffle </div>
          </button>

          <button
            onClick={checkResults}
            style={{
              flex: 1,
              padding: "8px 12px",
              borderRadius: "6px",
              border: "none",border:"2px solid rgba(144, 202, 249,1)",
              background: "#ffffff",
              color: "#222222",
              cursor: "pointer",
            }}
          >
            <div style={{display:"flex",justifyContent:"left",gap:"10px"}}>
            <ArrowBigUpDash color="rgba(144, 202, 249,1)" size={20}/> Check Result </div>
          </button>
        </div> 

        {/* 🔹 Show Score */}
        {score && (
          <div
            style={{
              marginTop: "15px",
              padding: "10px 15px",
              borderRadius: "6px",
              background: "#f0f0f0",
              fontWeight: "600",
            }}
          >
            🎯 Correct: {score.correctCount}/{data.length} <br />
            💯 Marks: {score.total} / {score.maxMarks}
          </div>
        )}
    
    </div>
  );
}